if (!customElements.get('s19-filter')) {
  customElements.define(
    's19-filter',
    class S19Filter extends HTMLElement {
      connectedCallback() {
        this.grid = this.closest('section').querySelector('.s19-grid');
        this.buttons = Array.from(this.querySelectorAll('[data-filter]'));
        this.buttons.forEach((button) => button.addEventListener('click', () => this.select(button)));
      }

      select(active) {
        const filter = active.dataset.filter;
        const handles = active.dataset.products || '';
        this.buttons.forEach((button) => button.setAttribute('aria-pressed', button === active ? 'true' : 'false'));

        let visible = 0;
        this.grid.querySelectorAll('.s19-card').forEach((card) => {
          const show = filter === 'all' || handles.includes(` ${card.dataset.handle} `);
          card.hidden = !show;
          if (show) {
            // Keep the column stagger tidy for whatever is left on screen.
            card.style.setProperty('--i', visible % 4);
            visible += 1;
          }
        });
      }
    }
  );
}
